const animatedTabSection = [
    {
        selector: '[data-animated-tab-section]',
        path: { filename: 'animatedTabSection' },
    },
];

export { animatedTabSection };
